import Link from 'next/link';
import { FunctionComponent } from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

interface Props {
  link: string;
  text: string;
}

const BackButton: FunctionComponent<Props> = ({ link, text }) => {
  return (
    <Link href={link} passHref>
      <a className="flex items-center space-x-4 font-light">
        <ArrowLeftIcon className="h-5 w-5 text-zinc-200" />
        <span>{text}</span>
      </a>
    </Link>
  );
};

export default BackButton;
